<template>
    <Modal v-model="show"
        title="标准卡信息"
        :width="60"
        class-name="vertical-center-modal"
        @on-ok="onSave"
        @on-cancel="show = false"
        @on-visible-change="onShowChange"
        :footer-hide="readOnly">
        <Spin v-if="innerSpin"
            size="large"
            fix></Spin>
        <div style="height:500px;overflow:scroll;padding-left:20px;padding-right:20px;">
            <Form ref="standardForm"
                :model="form"
                :rules="ruleValidate"
                label-position="top"
                class="small-form">
                <Row :gutter="16">
                    <Col span="16">
                    <Row :gutter="16">
                        <Col span="12">
                        <FormItem label="大类"
                            prop="standardMainCategoryUuid">
                            <Select v-model="form.standardMainCategoryUuid"
                                filterable>
                                <Option v-for="item in mainCategoryOptions"
                                    :key="item.mainCategoryUuid"
                                    :value="item.mainCategoryUuid">{{ item.mainCategoryName }}</Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="小类"
                            prop="standardCardRelateSubCategoryUuid">
                            <Select v-model="
                                            form.standardCardRelateSubCategoryUuid
                                        "
                                filterable>
                                <Option v-for="item in subCategoryOptions"
                                    :key="item.subCategoryUuid"
                                    :value="item.subCategoryUuid">{{ item.subCategoryName }}</Option>
                            </Select>
                        </FormItem>
                        </Col>

                        <Col span="12">
                        <FormItem label="标准卡名称"
                            prop="standardCardName">
                            <Input v-model="form.standardCardName"></Input>
                        </FormItem>
                        </Col>

                        <Col span="12">
                        <FormItem label="描述">
                            <Input v-model="form.standardCardDesc"></Input>
                        </FormItem>
                        </Col>

                        <Col span="12">
                        <FormItem label="销售期限">
                            <integer-input v-model="form.standardCardSalesPeriod"
                                :min="0"
                                :max="100" />
                        </FormItem>
                        </Col>
                    </Row>
                    </Col>
                    <Col span="8">
                    <FormItem label="图片"
                        prop="standardCardImageFile">
                        <single-file-upload-with-name v-model="form.standardCardImageFile" />
                    </FormItem>
                    </Col>

                    <Col span="4">
                    </Col>
                </Row>

                <standard-card-form-items v-model="descJson" />
            </Form>
        </div>

        <div slot="footer">
            <Button type="primary"
                size="default"
                @click="onSave">保存
            </Button>
        </div>
    </Modal>
</template>

<script>
import {
    FORM_EDIT_MODE_CREATE,
    FORM_EDIT_MODE_MODIFY
} from "@/view/mixins/form-edit-mode";
import {
    APPROVAL_INREVIEW,
    APPROVAL_NO,
    APPROVAL_YES,
    approvalColor,
    approvalFormat
} from "@/libs/baseModelFormat";
import SingleFileUploadWithName from "@/components/single-file-upload-with-name/SingleFileUploadWithName";
import IntegerInput from "@/components/number-input/integer-input";
import { getDefaultStandardCardDesc } from "@/view/product-management/standardCard-management/StandardCardDescType";
import StandardCardFormItems from "@/view/product-management/standardCard-management/StandardCardFormItems";

import {
    getStandardCardDetail,
    pageInit4StandardCardEdit,
    saveStandardCard,
    updateStandardCardApprove
} from "@/api/modules/product-management/standardCard-management";

export default {
    name: "StandardCardEdit",
    components: {
        SingleFileUploadWithName,
        StandardCardFormItems,
        IntegerInput
    },
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        const defaultDesc = getDefaultStandardCardDesc();

        return {
            show: false,
            innerSpin: false,
            cardUuid: "",
            APPROVAL_INREVIEW,
            FORM_EDIT_MODE_CREATE,
            formEditMode: FORM_EDIT_MODE_CREATE,
            form: {
                standardCardUuid: "",
                standardCardName: "",
                standardCardDesc: "",
                standardCardApproval: "",
                standardCardDescJson: "",
                standardCardImageFile: "",
                standardCardRelateSubCategoryUuid: "",
                standardMainCategoryUuid: "",
                standardCardSalesPeriod: 0
            },
            ruleValidate: {
                standardCardName: [
                    { required: true, message: " ", trigger: "blur" }
                ],
                standardCardImageFile: [
                    { required: true, message: " ", trigger: "blur" }
                ]
            },
            descJson: defaultDesc,
            approvalSource: [],
            mainCategoriesSource: [],
            subCategoriesSource: [],
            mainCategoryOptions: [],
            subCategoryOptions: []
        };
    },
    watch: {
        "form.standardMainCategoryUuid": {
            deep: true,
            immediate: true,
            handler: function (newVal, oldVal) {
                // console.log('productForm.productMainCategoryUuid');

                // this.productForm.productSubCategoryUuid = '';
                this.subCategoryOptions = [];
                if (newVal !== "") {
                    this.subCategoryOptions = this.subCategoriesSource.filter(
                        item => item.subCategoryMainUuid === newVal
                    );
                }
            }
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(cardUuid) {
            this.cardUuid = cardUuid;
            this.show = true;
        },
        approvalColor,
        approvalFormat,
        init() {
            this.approvalSource = [];
            this.approvalSource.push({
                val: APPROVAL_NO,
                label: approvalFormat(APPROVAL_NO)
            });
            this.approvalSource.push({
                val: APPROVAL_YES,
                label: approvalFormat(APPROVAL_YES)
            });
            this.approvalSource.push({
                val: APPROVAL_INREVIEW,
                label: approvalFormat(APPROVAL_INREVIEW)
            });

            this.innerSpin = true;
            pageInit4StandardCardEdit().then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.mainCategoriesSource = res.data.mainCategories;
                    this.subCategoriesSource = res.data.subCategories;

                    this.mainCategoryOptions = this.mainCategoriesSource;

                    // const query = this.$route.query;
                    if (this.cardUuid) {
                        this.formEditMode = FORM_EDIT_MODE_MODIFY;
                        getStandardCardDetail(this.cardUuid).then(res => {
                            if (res.code === 0) {
                                this.form = Object.assign(
                                    this.form,
                                    res.data.standardCard
                                );
                                this.descJson = Object.assign(
                                    this.descJson,
                                    JSON.parse(this.form.standardCardDescJson)
                                );
                            }
                        });
                    }
                }
            });
        },
        onSave() {
            this.$refs.standardForm.validate(valid => {
                if (!valid) {
                    this.$Message.error("表单验证失败!");
                    return;
                }

                this.form.standardCardDescJson = JSON.stringify(this.descJson);
                const data = Object.assign(
                    { formEditMode: this.formEditMode },
                    this.form
                );

                this.innerSpin = true;
                saveStandardCard(data)
                    .then(res => {
                        this.innerSpin = false;
                        if (res.code === 0) {
                            this.$Modal.success({
                                title: "保存成功",
                                onOk: () => {
                                    this.$parent.init();
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.innerSpin = false;
                    });
            });
        },
        onApproval(approval) {
            const submitData = {
                standardCardUuid: this.form.standardCardUuid,
                standardCardApproval: this.form.standardCardApproval
            };
            this.innerSpin = true;
            updateStandardCardApprove(submitData)
                .then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: "保存成功",
                            onOk: () => { }
                        });
                    }
                })
                .catch(() => {
                    this.innerSpin = false;
                });
        }
    }
};
</script>

<style lang="less">
</style>

